import { S3FileWidget } from './components';

const applyConfig = (config) => {
  const publicPath = new URL(config.settings.publicURL).pathname.replace(
    /\/$/,
    '',
  );
  config.settings = {
    ...config.settings,
    nonContentRoutes: [...config.settings.nonContentRoutes],
    S3ApiPath: `${publicPath}/attachment`,
  };
  config.widgets = {
    ...config.widgets,
    widget: {
      ...config.widgets.widget,
      s3file: S3FileWidget,
    },
    id: {
      ...config.widgets.id,
      s3file: S3FileWidget,
    },
  };

  if (__SERVER__) {
    config.settings = {
      ...config.settings,
      S3EndpointUrl: process.env['S3_ENDPOINT_URL'] || 'http://localhost:9000',
      S3AccessKey: process.env['S3_ACCESS_KEY'] || 'ilpokey',
      S3SecretKey: process.env['S3_SECRET_KEY'] || 'ilposecret',
      S3BucketName: process.env['S3_BUCKET_NAME'] || 'vasara',
      S3KeyPrefix: process.env['S3_KEY_PREFIX'] || 'ILPO/',
      S3ExpirySeconds: parseInt(process.env['S3_EXPIRY_SECONDS'] || '60', 10),
    };

    let apiPath;
    if (config.settings.internalApiPath) {
      apiPath = config.settings.internalApiPath;
    } else if (__DEVELOPMENT__ && config.settings.devProxyToApiPath) {
      apiPath = config.settings.devProxyToApiPath;
    } else {
      apiPath = config.settings.apiPath;
    }

    const middleware = require('./middleware');
    config.settings.expressMiddleware = [
      middleware.default(apiPath),
      ...config.settings.expressMiddleware,
    ];
  }

  return config;
};

export default applyConfig;
